/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CopilotInputs */

const en_nav_copilot = /** @type {(inputs: Nav_CopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copilot`)
};

const es_nav_copilot = /** @type {(inputs: Nav_CopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copilot`)
};

/**
* | output |
* | --- |
* | "Copilot" |
*
* @param {Nav_CopilotInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_copilot = /** @type {((inputs?: Nav_CopilotInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CopilotInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_copilot(inputs)
	return es_nav_copilot(inputs)
});